<script setup lang="ts">
const { data: page } = await useAsyncData('faq', () => queryCollection('faq').first())

const title = page.value?.seo?.title || page.value?.title
const description = page.value?.seo?.description || page.value?.description

useSeoMeta({
  title,
  ogTitle: title,
  description,
  ogDescription: description
})

// Native <details>/<summary> statt JS-Accordion: Fragen und Antworten stehen so
// garantiert im ausgelieferten HTML (kein Nachladen, keine Abhängigkeit von
// Hydration) und sind das zitierfreundlichste Format für Crawler und LLMs.
useJsonLd(() => page.value
  ? {
      '@type': 'FAQPage',
      '@id': `${SITE_URL}/faq/#faqpage`,
      'mainEntity': page.value.sections.flatMap(section => section.items.map(item => ({
        '@type': 'Question',
        'name': item.label,
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': item.content
        }
      })))
    }
  : null, 'faq-schema')
</script>

<template>
  <div v-if="page">
    <UPageHero
      :title="page.title"
      :description="page.description"
    />

    <UPageSection>
      <UContainer class="max-w-3xl">
        <div
          v-for="section in page.sections"
          :key="section.id"
          class="mb-10"
        >
          <h2 class="text-2xl font-semibold mb-4">
            {{ section.title }}
          </h2>
          <div class="rounded-lg ring ring-default divide-y divide-default overflow-hidden">
            <details
              v-for="(item, index) in section.items"
              :key="index"
              class="group p-4 sm:px-6"
            >
              <summary class="flex items-center justify-between gap-2 cursor-pointer list-none marker:content-none">
                <h3 class="text-base font-medium text-highlighted">
                  {{ item.label }}
                </h3>
                <UIcon
                  name="i-lucide-chevron-down"
                  class="shrink-0 size-5 transition-transform duration-200 group-open:rotate-180"
                />
              </summary>
              <p class="pt-3.5 text-base text-muted">
                {{ item.content }}
              </p>
            </details>
          </div>
        </div>
      </UContainer>
    </UPageSection>
  </div>
</template>
